export const CONFIG:Config = {
    workflowGroups: [[]],
    workflowGroupsFitdoc: "prefix-value",
    hideClientcode: false,
    defaultClientcode: '',
    maxWorkflowClones: 5,
    workflow: {
        approve: {
            requiredRemark: false
        },
        reject: {
            requiredRemark: false
        },
        viewTableLayout: true,
        portal: {
            enable: true
        }
    },
    onedrive: {
        enable: true,
        fitdoc_foldername: "__FITDOC__",
        fitdoc_tmp_foldername: "temp",
        fitdoc_doctypes_foldername: "doctypes",
        fitdoc_trash_foldername: "trash",
        fitdoc_doctypes_split: "$"
    },
    scanner: {
        navigation: true
    },
    company: {
        'Alumac': {
            view_article_catalogue: true
        },
        'Despiegelaere': {
            search_default_days: 365,
            search_enable_searchcontent: true
        }
    }
}

type Config = {
    workflowGroups: string[][],
    workflowGroupsFitdoc: "prefix-value" | "trailing-type",
    hideClientcode: boolean,
    defaultClientcode: string,
    maxWorkflowClones: number,
    company?: {
        [companyName:string]: {
            view_article_catalogue?: boolean
            search_default_days?: number
            search_enable_searchcontent?: boolean
        }
    },
    workflow: {
        approve: {
            requiredRemark: boolean
        },
        reject: {
            requiredRemark: boolean
        },
        viewTableLayout: boolean,
        portal: {
            enable: boolean
        }
    },
    onedrive: {
        enable: boolean
        fitdoc_foldername: string
        fitdoc_tmp_foldername: string
        fitdoc_doctypes_foldername: string
        fitdoc_trash_foldername: string
        fitdoc_doctypes_split: string
    },
    scanner: {
        navigation: boolean
    }
}

// DEFAULT:
// export const CONFIG:Config = {
//     workflowGroups: [[]],
//     workflowGroupsFitdoc: "prefix-value",
//     hideClientcode: false,
//     defaultClientcode: '',
//     maxWorkflowClones: 5,
//     workflow: {
//         approve: {
//             requiredRemark: false
//         },
//         reject: {
//             requiredRemark: false
//         }
//     }
// }

// LECOT:
// export const CONFIG:Config = {
//     workflowGroups: [['ANACODE', 'PROJID', 'BHREK', 'AKFBRUT']],
//     workflowGroupsFitdoc: "trailing-type",
//     hideClientcode: false,
//     defaultClientcode: '',
//     maxWorkflowClones: 5,
//     workflow: {
//         approve: {
//             requiredRemark: false
//         },
//         reject: {
//             requiredRemark: true
//         }
//     }
// }